import { defaultStrokeColor, mapActive } from "../utils/map-utils";
import { CustomSource } from "../models/CustomSource";
import {
  defaultStreetViewState,
  StreetViewState,
} from "../models/StreetViewPosition";
import { FeatureCollection } from "geojson";

export class StreetViewMapSource {
  map: mapboxgl.Map;

  streetViewState = defaultStreetViewState();
  strokeColor = defaultStrokeColor;

  constructor(map: mapboxgl.Map) {
    this.map = map;

    this.config();
  }

  clear() {
    if (mapActive(this.map)) {
      this.map.removeLayer(symbolLayerConfig.id);
      this.map.removeSource(sourceName);
    }
  }

  private config() {
    if (mapActive(this.map) && !this.map.getSource(sourceName)) {
      this.map.addSource(sourceName, sourceConfig);
      this.map.addLayer(symbolLayerConfig);
    }
  }

  update(value: Partial<StreetViewState>) {
    this.streetViewState = { ...this.streetViewState, ...value };

    if (mapActive(this.map)) {
      const source = this.map.getSource(sourceName) as mapboxgl.GeoJSONSource;

      const featCollection: FeatureCollection = {
        type: "FeatureCollection",
        features: [],
      };

      if (this.streetViewState.position) {
        featCollection.features.push({
          type: "Feature",
          properties: { heading: this.streetViewState.pov.heading },
          geometry: {
            type: "Point",
            coordinates: [
              this.streetViewState.position.lng,
              this.streetViewState.position.lat,
            ],
          },
        });
      }

      source?.setData(featCollection);
    }
  }
}

const sourceName = CustomSource.StreetView;
const sourceConfig: mapboxgl.GeoJSONSourceSpecification = {
  type: "geojson",
  promoteId: "id",
  data: {
    type: "FeatureCollection",
    features: [],
  },
};

const symbolLayerName = `${sourceName}-symbol`;
const symbolLayerConfig: mapboxgl.SymbolLayerSpecification = {
  id: symbolLayerName,
  type: "symbol",
  source: sourceName,
  layout: {
    "icon-image": "camera-icon",
    "icon-rotate": ["get", "heading"],
    "icon-rotation-alignment": "map",
    "icon-allow-overlap": true,
    "icon-ignore-placement": true,
  },
};
